module.exports = __webpack_public_path__ + "static/media/flag-ne.725430f0.webp";